(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', 'kotlin', 'kotlinx-serialization-kotlinx-serialization-core-js-legacy'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('kotlin'), require('kotlinx-serialization-kotlinx-serialization-core-js-legacy'));
  else {
    if (typeof kotlin === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-common-types-js-legacy'. Its dependency 'kotlin' was not found. Please, check whether 'kotlin' is loaded prior to 'kvision-kvision-common-types-js-legacy'.");
    }if (typeof this['kotlinx-serialization-kotlinx-serialization-core-js-legacy'] === 'undefined') {
      throw new Error("Error loading module 'kvision-kvision-common-types-js-legacy'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core-js-legacy' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core-js-legacy' is loaded prior to 'kvision-kvision-common-types-js-legacy'.");
    }root['kvision-kvision-common-types-js-legacy'] = factory(typeof this['kvision-kvision-common-types-js-legacy'] === 'undefined' ? {} : this['kvision-kvision-common-types-js-legacy'], kotlin, this['kotlinx-serialization-kotlinx-serialization-core-js-legacy']);
  }
}(this, function (_, Kotlin, $module$kotlinx_serialization_kotlinx_serialization_core_js_legacy) {
  'use strict';
  var NullableSerializer = $module$kotlinx_serialization_kotlinx_serialization_core_js_legacy.kotlinx.serialization.internal.NullableSerializer;
  var Kind_OBJECT = Kotlin.Kind.OBJECT;
  var PluginGeneratedSerialDescriptor = $module$kotlinx_serialization_kotlinx_serialization_core_js_legacy.kotlinx.serialization.internal.PluginGeneratedSerialDescriptor;
  var internal = $module$kotlinx_serialization_kotlinx_serialization_core_js_legacy.kotlinx.serialization.internal;
  var equals = Kotlin.equals;
  var UnknownFieldException = $module$kotlinx_serialization_kotlinx_serialization_core_js_legacy.kotlinx.serialization.UnknownFieldException;
  var GeneratedSerializer = $module$kotlinx_serialization_kotlinx_serialization_core_js_legacy.kotlinx.serialization.internal.GeneratedSerializer;
  var MissingFieldException_init = $module$kotlinx_serialization_kotlinx_serialization_core_js_legacy.kotlinx.serialization.MissingFieldException_init_61zpoe$;
  var Kind_CLASS = Kotlin.Kind.CLASS;
  var split = Kotlin.kotlin.text.split_ip8yn$;
  var drop = Kotlin.kotlin.text.drop_6ic1pp$;
  var getOrNull = Kotlin.kotlin.collections.getOrNull_yzln2o$;
  function KFile(name, size, content) {
    KFile$Companion_getInstance();
    if (content === void 0)
      content = null;
    this.name = name;
    this.size = size;
    this.content = content;
  }
  function KFile$Companion() {
    KFile$Companion_instance = this;
  }
  KFile$Companion.prototype.serializer = function () {
    return KFile$$serializer_getInstance();
  };
  KFile$Companion.$metadata$ = {kind: Kind_OBJECT, simpleName: 'Companion', interfaces: []};
  var KFile$Companion_instance = null;
  function KFile$Companion_getInstance() {
    if (KFile$Companion_instance === null) {
      new KFile$Companion();
    }return KFile$Companion_instance;
  }
  function KFile$$serializer() {
    this.descriptor_8timtw$_0 = new PluginGeneratedSerialDescriptor('io.kvision.types.KFile', this, 3);
    this.descriptor.addElement_ivxn3r$('name', false);
    this.descriptor.addElement_ivxn3r$('size', false);
    this.descriptor.addElement_ivxn3r$('content', true);
    KFile$$serializer_instance = this;
  }
  Object.defineProperty(KFile$$serializer.prototype, 'descriptor', {configurable: true, get: function () {
    return this.descriptor_8timtw$_0;
  }});
  KFile$$serializer.prototype.serialize_55azsf$ = function (encoder, value) {
    var output = encoder.beginStructure_24f42q$(this.descriptor);
    output.encodeStringElement_iij8qq$(this.descriptor, 0, value.name);
    output.encodeIntElement_ptg7oe$(this.descriptor, 1, value.size);
    if (!equals(value.content, null) || output.shouldEncodeElementDefault_szpzho$(this.descriptor, 2))
      output.encodeNullableSerializableElement_qw92s8$(this.descriptor, 2, internal.StringSerializer, value.content);
    output.endStructure_24f42q$(this.descriptor);
  };
  KFile$$serializer.prototype.deserialize_bq71mq$ = function (decoder) {
    var index;
    var bitMask0 = 0;
    var local0, local1, local2;
    var input = decoder.beginStructure_24f42q$(this.descriptor);
    loopLabel: while (true) {
      index = input.decodeElementIndex_24f42q$(this.descriptor);
      switch (index) {
        case 0:
          local0 = input.decodeStringElement_szpzho$(this.descriptor, 0);
          bitMask0 |= 1;
          break;
        case 1:
          local1 = input.decodeIntElement_szpzho$(this.descriptor, 1);
          bitMask0 |= 2;
          break;
        case 2:
          local2 = input.decodeNullableSerializableElement_8viuyw$(this.descriptor, 2, internal.StringSerializer, local2);
          bitMask0 |= 4;
          break;
        case -1:
          break loopLabel;
        default:throw new UnknownFieldException(index);
      }
    }
    input.endStructure_24f42q$(this.descriptor);
    return KFile_init(bitMask0, local0, local1, local2, null);
  };
  KFile$$serializer.prototype.childSerializers = function () {
    return [internal.StringSerializer, internal.IntSerializer, new NullableSerializer(internal.StringSerializer)];
  };
  KFile$$serializer.$metadata$ = {kind: Kind_OBJECT, simpleName: '$serializer', interfaces: [GeneratedSerializer]};
  var KFile$$serializer_instance = null;
  function KFile$$serializer_getInstance() {
    if (KFile$$serializer_instance === null) {
      new KFile$$serializer();
    }return KFile$$serializer_instance;
  }
  function KFile_init(seen1, name, size, content, serializationConstructorMarker) {
    var $this = serializationConstructorMarker || Object.create(KFile.prototype);
    if ((seen1 & 1) === 0)
      throw MissingFieldException_init('name');
    else
      $this.name = name;
    if ((seen1 & 2) === 0)
      throw MissingFieldException_init('size');
    else
      $this.size = size;
    if ((seen1 & 4) === 0)
      $this.content = null;
    else
      $this.content = content;
    return $this;
  }
  KFile.$metadata$ = {kind: Kind_CLASS, simpleName: 'KFile', interfaces: []};
  KFile.prototype.component1 = function () {
    return this.name;
  };
  KFile.prototype.component2 = function () {
    return this.size;
  };
  KFile.prototype.component3 = function () {
    return this.content;
  };
  KFile.prototype.copy_zeh6sj$ = function (name, size, content) {
    return new KFile(name === void 0 ? this.name : name, size === void 0 ? this.size : size, content === void 0 ? this.content : content);
  };
  KFile.prototype.toString = function () {
    return 'KFile(name=' + Kotlin.toString(this.name) + (', size=' + Kotlin.toString(this.size)) + (', content=' + Kotlin.toString(this.content)) + ')';
  };
  KFile.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.name) | 0;
    result = result * 31 + Kotlin.hashCode(this.size) | 0;
    result = result * 31 + Kotlin.hashCode(this.content) | 0;
    return result;
  };
  KFile.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && (Kotlin.equals(this.name, other.name) && Kotlin.equals(this.size, other.size) && Kotlin.equals(this.content, other.content)))));
  };
  var KV_DEFAULT_DATE_FORMAT;
  Object.defineProperty(KFile, 'Companion', {get: KFile$Companion_getInstance});
  Object.defineProperty(KFile, '$serializer', {get: KFile$$serializer_getInstance});
  var package$io = _.io || (_.io = {});
  var package$kvision = package$io.kvision || (package$io.kvision = {});
  var package$types = package$kvision.types || (package$kvision.types = {});
  package$types.KFile_init_7vc2qp$ = KFile_init;
  package$types.KFile = KFile;
  Object.defineProperty(package$types, 'KV_DEFAULT_DATE_FORMAT', {get: function () {
    return KV_DEFAULT_DATE_FORMAT;
  }});
  KFile$$serializer.prototype.typeParametersSerializers = GeneratedSerializer.prototype.typeParametersSerializers;
  KV_DEFAULT_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
  return _;
}));

//# sourceMappingURL=kvision-kvision-common-types-js-legacy.js.map
